<template>
  <div>
    <article>
      <section class="intro">
        <h1>{{ roomInfo.name }}</h1>
        <p>{{ roomInfo.description }}</p>
        <div class="price-tag">
          <span>Weekday ${{ roomInfo.normalDayPrice }}</span>
          <span>Holiday ${{ roomInfo.holidayPrice }}</span>
        </div>
      </section>
      <section>
        <ul class="detail">
          <li>Guest(s): {{roomInfo.descriptionShort.GuestMin}}~{{ roomInfo.descriptionShort.GuestMax}}</li>
          <li>
            Footage: {{ roomInfo.descriptionShort.Footage }}
            <i class="unit">
              m
              <sup>2</sup>
            </i>
          </li>
          <li>Private-Bath: {{roomInfo.descriptionShort['Private-Bath']}}</li>
          <li>
            <span>Bed(s):&nbsp;</span>
            {{roomInfo.descriptionShort.Bed.join(', ')}}
          </li>
          <li>Check In: {{roomInfo.checkInAndOut.checkInEarly}}~{{roomInfo.checkInAndOut.checkInLate}}</li>
          <li>Check Out: {{roomInfo.checkInAndOut.checkOut}}</li>
        </ul>
      </section>
      <section>
        <ul class="amenities">
          <li v-for="(value, key) in roomInfo.amenities" :key="key" :class="{ isCheck: value }">
            <div class="box"></div>
            <span>{{ key }}</span>
          </li>
        </ul>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  props: {
    roomInfo: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 33%;
}
section {
  border-top: 1px solid var(--text-color-lighter);
  padding: var(--g-xl) 0;
  &:first-child {
    border-top: none;
  }
  p {
    margin: var(--g-xxl) 0;
  }
}

ul {
  display: flex;
  flex-flow: row wrap;
  li {
    margin: 0.4em 0;
    line-height: 1.3em;
  }
  &.detail li {
    width: 25%;
    min-width: 200px;
    color: var(--text-color-lighter);
  }
  &.amenities li {
    width: 20%;
    min-width: 170px;
    display: flex;
    overflow: hidden;
    white-space: nowrap;
    color: var(--text-color-lightest);
    &.isCheck {
      color: var(--text-color-darker);
      .box {
        border: 1px solid var(--text-color-darker);
        background-color: var(--text-color-darker);
      }
    }
  }
}

.box {
  border: 1px solid var(--text-color-lightest);
  width: 1em;
  height: 1em;
  margin-right: var(--g-m);
}

.price-tag {
  display: flex;
  flex-flow: wrap;
  justify-content: flex-end;
  span {
    margin-left: var(--g-xxl);
    margin-bottom: var(--g-s);
    font-weight: bold;
  }
}

.unit {
  position: relative;
}
sup {
  font-size: var(--fs-s);
  position: absolute;
  top: -0.3em;
}
</style>
